import { render } from "./FooterBar.vue?vue&type=template&id=7132c9aa&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=7132c9aa&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7132c9aa"]])

export default __exports__